<template>
    <f7-page name="FirstTracker">
        <f7-navbar
            :title-large="`New feature!`"
            large
            no-hairline
            large-transparent
        >
            <f7-nav-left>
                <!-- <f7-link
                    back
                    icon="ion-ios-arrow-left"
                    style="color: gray"
                /> -->
            </f7-nav-left>
            <f7-nav-title>New feature!</f7-nav-title>
            <f7-nav-right>
                <!-- <f7-link
                    href="#"
                    style="padding-right: 10px"
                    @click="closePopup"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                    >
                        <g
                            fill="none"
                            fill-rule="evenodd"
                            stroke="gray"
                            stroke-linecap="square"
                            stroke-width=".75"
                            transform="translate(-2)"
                        >
                            <path d="M3,1 L18,16" />
                            <path
                                d="M4.29545455,0.293103448 L16.7045455,16.7068966"
                                transform="rotate(78 10.5 8.5)"
                            />
                        </g>
                    </svg>
                </f7-link> -->
            </f7-nav-right>
        </f7-navbar>

        <f7-block style="margin-top: 6px">

            <h2>You have unlocked</h2>

            <img
                style="margin: 14px auto; width: 200px;"
                src="../../img/0.4/pulse/Pulse_2.png"
            >

            <p style="font-size: 28px; line-height: 30px">
                Coral's Sexual<br>Pulse tracker<br>
            </p>
            <br>
            <div class="ansButtons">

                <f7-button
                    color="red"
                    fill
                    round
                    @click="goToTracker"
                >CONTINUE
                </f7-button>
            </div>

        </f7-block>

    </f7-page>
</template>

<script>
export default {
    store: ['api', 'user'],
    data () {
        return {
            startTitles: [
                '',
                'Desire types',
                'Journey over destination',
                'Pleasure her better',
                'Pleasure him better',
                'Always in sync?',
                'Effects on pleasure',
                'Women aren’t complicated',
                'Men aren’t machines',
                'Talking sex '
            ],
            currentId: 0,
            slideIndex: 0,
            renderSub: 0,
            mySwiper: null
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    created: function () {
        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
    },
    mounted: function () {
        // f7.statusbar.setBackgroundColor('#65749B');
        // f7.statusbar.setTextColor('white');
    },
    methods: {
        goToTracker: function () {
            f7.popup.get('#popup').open();
            setTimeout(() => {
                this.$f7router.view.router.navigate('/units/285', { ignoreCache: true });
                if (!pgap && location.hostname !== 'localhost') {
                    window.history.pushState(null, "", '/web/units/285');
                }
            }, 200);
        },
        closePopup: function () {
            if (this.$f7router.view.main) {
                f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
            } else {
                if (f7.popup.get(`#${this.$f7router.view.name}`)) {
                    f7.popup.get(`#${this.$f7router.view.name}`).open();
                    f7.popup.get(`#${this.$f7router.view.name}`).close();
                }
            }
            if (!pgap) window.history.pushState(null, "", '/web' + f7.views['main'].router.currentRoute.path);
        },
        done: function () { }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
.bottom {
    position: absolute;
    bottom: 40px;
}
.coralButton {
    font-size: 18px;
    color: white;
    background: #a5acc4;
    border-radius: 22px;
    padding: 15px 30px;
}
#slides {
    height: 100%;
    padding-top: 0px;
}
.checkmark {
    z-index: 9999;
    margin: 0 auto;
    left: 50%;
    line-height: 67px;
    background: @coral;
    color: white;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    i {
        color: white;
        font-size: 40px;
        line-height: 78px;
    }
}
.courseImage {
    margin: 0 auto;
    width: 120px;
    height: 120px;
    background-color: #eee;
    border-radius: 16px;
    box-shadow: 0px 5px 25px -10px rgba(0, 0, 0, 0.7);
    background-size: cover;
}
.miniProgress {
    width: 50px;
    overflow: hidden;
    height: 4px;
    background: #eee;
    top: 10px;
    position: absolute;
    left: 135px;
    border-radius: 3px;
    .miniProgressBar {
        height: 4px;
        border-radius: 3px;
        background: @green;
    }
}
</style>
